import MicrofrontendViewer from "@/components/MicrofrontendViewer";

const SoftTagManager = () => {
  return (
    <div className="w-full">
      <MicrofrontendViewer
        url={import.meta.env.VITE_APP_STM_URL || "http://localhost:3001"}
      />
    </div>
  );
};

export default SoftTagManager;
